<template>
	<div class="product-list">
    <!-- <div class="product-list-header" @click="productListClick(items)">
      <span class="header-title">{{title}}</span>
    </div> -->
    <div class="product-list-body">
      <img v-bind:style="getBannerStyle" :src="items.photo" alt="" @click="productListClick(items)"  srcset="">
      <home-product-body v-for='(item, index) in dataList'  :item="item" :index="index"  :key='index'></home-product-body>
    </div>
  </div>
</template>

<script>
import { Header, Indicator, Toast } from 'mint-ui';
import HomeProductBody from './HomeProductBody';
import { mapState, mapMutations, mapActions } from 'vuex';
import more from '@/assets/image/home/more.jpg'

export default {
  name: 'HomeProductList',
  data() {
    return {
      more,
      dataList:[],
    };
  },
  props: ['items', 'title', 'type','id'],
  components: {
    HomeProductBody
  },
  mounted(){
    if(!this.dataList || this.dataList.length <1){
      this.fetchTopicProductList({topic_id:this.id,page:1,per_page:100000}).then(
        response => {
          this.dataList = response.dataList
        },
        error => {
          console.dir(error)
        }
      )
    }
  },
  computed: {
    ...mapState({
      isOnline: state => state.auth.isOnline,         
      config: state => state.config.config,    
      banners: state => state.home.banners,
      recentlyProducts: state => state.home.recentlyProducts
    }),
    getProductStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width / 3 - 40 - 1;
      let itemHeight = itemWidth * (132.0 / 94.0) -10;
      return {
        'padding-top':'10px',
        'padding-left':'10px',
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
    getBannerStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      let itemHeight = width * (94.0 / 188.0)
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
  },
  methods: {
    ...mapMutations({
      saveToken: 'saveToken'
    }),
    ...mapActions({
      fetchTopicProductList: 'fetchTopicProductList'
    }),
    productListClick: function(items) {
      this.$router.push({
        name: 'topic',
        query: { id: items.id ,display_area:1}
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list {
  background: #FFFFFF;
  margin-top: 12px;
  margin-bottom: 12px;
  border-top: 2px #eeeeee solid;
  margin-bottom: 50px;
  .product-list-header {
    display: flex;
    height: 40px;
    padding: 0px 5px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #F5F5F5;
    .header-title {
      margin-left: 10px;
      padding-left:10px;
      border-left: 2px #f17100 solid;
      font-size: 16px;
      line-height: 16px;
      color: #333333;
    }
    .header-icon {
      width: 20px;
      height: 20px;
    }
  }
  .product-list-body {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/topic-list/child/HomeProductList.vue